import { Link } from 'react-router-dom'
import { Terminal, Lock, ArrowLeft } from 'lucide-react'

export default function BlogPost() {
  return (
    <div className="bg-terminal-bg min-h-screen">
      <div className="container mx-auto px-4 max-w-7xl py-20 flex flex-col items-center justify-center min-h-[80vh]">

        {/* Corner accents */}
        <div className="relative w-full max-w-2xl">
          <div
            className="p-10 md:p-14 border border-kgb-red/40 text-center relative overflow-hidden"
            style={{
              background: 'linear-gradient(135deg, rgba(220,20,60,0.08) 0%, rgba(10,10,10,1) 60%)',
            }}
          >
            {/* Corner brackets */}
            <div className="absolute top-0 left-0 w-16 h-0.5 bg-kgb-red" />
            <div className="absolute top-0 left-0 w-0.5 h-16 bg-kgb-red" />
            <div className="absolute top-0 right-0 w-16 h-0.5 bg-kgb-red" />
            <div className="absolute top-0 right-0 w-0.5 h-16 bg-kgb-red" />
            <div className="absolute bottom-0 left-0 w-16 h-0.5 bg-kgb-red" />
            <div className="absolute bottom-0 left-0 w-0.5 h-16 bg-kgb-red" />
            <div className="absolute bottom-0 right-0 w-16 h-0.5 bg-kgb-red" />
            <div className="absolute bottom-0 right-0 w-0.5 h-16 bg-kgb-red" />

            {/* Lock icon */}
            <div className="flex justify-center mb-6">
              <div className="p-4 border border-kgb-red/50 bg-black/60">
                <Lock className="text-kgb-red" size={36} />
              </div>
            </div>

            {/* Classification stamp */}
            <p className="font-mono text-[10px] uppercase tracking-[0.5em] text-kgb-red mb-4">
              ★ &nbsp; КГБ CLASSIFIED &nbsp; ★
            </p>

            {/* Header */}
            <h1 className="font-display font-bold text-4xl md:text-5xl text-white uppercase tracking-wider mb-3">
              ACCESS DENIED
            </h1>
            <div className="flex items-center gap-3 justify-center mb-6">
              <div className="h-px flex-1 bg-kgb-red/40" />
              <span className="font-mono text-xs text-kgb-red uppercase tracking-[0.3em]">
                OPERATION CLASSIFIED
              </span>
              <div className="h-px flex-1 bg-kgb-red/40" />
            </div>

            {/* Terminal block */}
            <div className="terminal-window text-left mb-8">
              <div className="terminal-header">
                <div className="flex gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-full bg-kgb-red opacity-80" />
                  <div className="w-2.5 h-2.5 rounded-full bg-status-warning opacity-80" />
                  <div className="w-2.5 h-2.5 rounded-full bg-status-online opacity-80" />
                </div>
                <span className="ml-3 text-[11px] font-mono text-text-gray tracking-wider">
                  ACCESS_CONTROL.sh
                </span>
              </div>
              <div className="terminal-body text-xs space-y-1 p-4">
                <p><span className="text-text-gray">$</span> requesting clearance level 5...</p>
                <p className="text-kgb-red">[DENIED] Insufficient authorization</p>
                <p><span className="text-text-gray">$</span> querying internal archives...</p>
                <p className="text-kgb-red">[DENIED] Record sealed by order of the Directorate</p>
                <p><span className="text-text-gray">$</span> attempting alternative access...</p>
                <p className="text-kgb-red">[DENIED] This operation does not exist</p>
                <p className="mt-2 flex items-center gap-1">
                  <span className="text-text-gray">$</span>
                  <span className="w-2 h-4 bg-kgb-red animate-blink inline-block" />
                </p>
              </div>
            </div>

            <p className="font-mono text-xs text-text-gray mb-8 leading-relaxed">
              Internal mission files are not yet declassified.
              <br />
              Return to the intel feed for open-source intelligence.
            </p>

            {/* Back link */}
            <Link
              to="/"
              className="inline-flex items-center gap-2 btn-mission"
            >
              <ArrowLeft size={14} />
              RETURN TO INTEL FEED
            </Link>

            {/* Terminal icon bottom */}
            <div className="flex justify-center mt-8 opacity-20">
              <Terminal size={20} className="text-kgb-red" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
